import React, { useEffect, useState } from "react";
import Carousel from "../components/home/Carousel";
import Manager from "../components/home/Manager";
import Rooms from "../components/home/Rooms";
import Info from "../components/home/Info";
// import Offers from "../components/home/Offers";
import Tesimonial from "../components/home/Tesimonial";
import {
  fetchCraftsmanshipSlider,
  fetchHomeSliders,
  fetchManagerMessage,
  fetchMissionVision,
  fetchOffers,
  fetchTestimonials,
} from "../api/HomeApi";
import {
  ICraftsmanshipSlider,
  IMissionVision,
  // IOffersData,
  ISliderData,
  ITestimonialData,
} from "../exports/interfaces";
import { dynamicFailed } from "../hooks/useToast";
import { useManagerContext } from "../context/HomeContext";
import { useLoader } from "../context/LoaderContext";
import { fetchRoomData } from "../api/RoomsApi";
import { useRoomContext } from "../context/RoomContext";

const Home: React.FC = () => {
  const { setLoading } = useLoader();
  const [sliderData, setSliderData] = useState<ISliderData[]>([]);
  const { setManagerData } = useManagerContext();
  const [missionVisionData, setMissionVisionData] = useState<IMissionVision[]>(
    []
  );
  const [craftsmanshipSlider, setCraftsmanshipSlider] = useState<
    ICraftsmanshipSlider[]
  >([]);
  // const [offers, setOffers] = useState<IOffersData[]>([]);
  const [testimonial, setTestimonial] = useState<ITestimonialData[]>([]);
  const { setRoomData } = useRoomContext();

  useEffect(() => {
    Promise.all([
      fetchHomeSliders(),
      fetchMissionVision(),
      fetchCraftsmanshipSlider(),
      fetchTestimonials(),
      fetchOffers(),
    ])
      .then(
        ([
          homeSliderData,
          missionVisionData,
          craftsmanshipSliderData,
          TestimonialData,
          OffersData,
        ]) => {
          setSliderData(homeSliderData);
          setMissionVisionData(missionVisionData);
          setCraftsmanshipSlider(craftsmanshipSliderData);
          setTestimonial(TestimonialData);
          // setOffers(OffersData);
          setLoading(false);
        }
      )
      .catch((error) => {
        setLoading(false);
        dynamicFailed(error.response.data.error.message);
      });
  }, [setLoading]);
  useEffect(() => {
    Promise.all([fetchManagerMessage(), fetchRoomData()])
      .then(([ManagerData, RoomData]) => {
        setManagerData(ManagerData);
        setRoomData(RoomData);
      })
      .catch((error) => {
        dynamicFailed(error.response.data.error.message);
      });
  }, [setManagerData, setRoomData]);

  return (
    <>
      <body
        data-rsssl="1"
        className="home page-template-default page page-id-662 tg_menu_transparent tg_lightbox_black centeralign2 loftloader-lite-enabled elementor-default elementor-kit-2567 elementor-page elementor-page-662 no-scroll"
      >
        <div
          id="page_content_wrapper"
          className="noheader"
          style={{ padding: "unset" }}
        >
          <div className="inner">
            <div className="inner_wrapper">
              <div className="sidebar_content full_width">
                <div
                  data-elementor-type="wp-post"
                  data-elementor-id="662"
                  className="elementor elementor-662"
                  data-elementor-settings="[]"
                >
                  <div className="elementor-inner">
                    <div className="elementor-section-wrap">
                      <Carousel sliderData={sliderData} />
                      <div id="block-search">
                        <div id="be-search-form" className="be-container">
                          <a
                            href="https://exely.com/"
                            rel="nofollow noreferrer"
                            target="_blank"
                          >
                            Loading...
                          </a>
                        </div>
                      </div>

                      <Manager />
                      <Rooms />
                      <Info
                        missionVisionData={missionVisionData}
                        craftsmanshipSlider={craftsmanshipSlider}
                      />
                      {/* <Offers offers={offers}/> */}
                      <Tesimonial testimonial={testimonial} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br className="clear" />
        </div>
      </body>
    </>
  );
};

export default Home;
